import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const LegalPage = ({ data }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${data.title} | HypeLab Marketing`;
  }, [data.title]);

  return (
    <div className="min-h-screen bg-[#F4F4F3] text-[#1C1917]">
      {/* Top bar */}
      <div className="border-b border-[#1C1917]/10 bg-[#F4F4F3]/80 backdrop-blur-sm sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12 py-5 flex items-center justify-between">
          <Link
            to="/"
            data-testid="legal-back-home"
            className="flex items-center gap-2 text-sm font-semibold text-[#78716C] hover:text-[#AA94FF] transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to HypeLab
          </Link>
          <img
            src="https://customer-assets.emergentagent.com/job_hyperlab-marketing/artifacts/bpjqoot1_EA48E728-648B-4FFC-984A-3BBF4550CA82.png"
            alt="HypeLab Marketing"
            className="h-8 w-auto"
          />
        </div>
      </div>

      <main className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-[#AA94FF] mb-4">
            Legal
          </p>
          <h1
            className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05] mb-4"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
          >
            {data.title}
          </h1>
          <p className="text-sm text-[#78716C] mb-10">
            Effective {data.effective_date}
          </p>

          {data.intro && (
            <p className="text-lg text-[#1C1917]/80 leading-relaxed mb-12 border-l-4 border-[#AA94FF] pl-6">
              {data.intro}
            </p>
          )}

          <div className="space-y-10">
            {data.sections.map((section, idx) => (
              <motion.section
                key={section.heading}
                data-testid={`legal-section-${idx}`}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: idx * 0.03 }}
              >
                <h2
                  className="text-xl sm:text-2xl font-bold mb-3"
                  style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
                >
                  {idx + 1}. {section.heading}
                </h2>
                <div className="text-base text-[#1C1917]/80 leading-relaxed whitespace-pre-line">
                  {section.body}
                </div>
              </motion.section>
            ))}
          </div>

          <div className="mt-16 pt-8 border-t border-[#1C1917]/10 text-sm text-[#78716C]">
            Questions? Email{' '}
            <a
              href="mailto:hello@hypelabmarketing.co.uk"
              className="text-[#AA94FF] font-semibold hover:underline"
            >
              hello@hypelabmarketing.co.uk
            </a>
          </div>
        </motion.div>
      </main>
    </div>
  );
};

export default LegalPage;
